import React from "react";
import { Container } from "@material-ui/core";

export const TableRoot = ({ children }) => {
  return (
    <Container
      maxWidth="xl"
      style={{
        boxShadow: "none",
        padding: 0,
        marginTop: "20px",
      }}
    >
      {children}
    </Container>
  );
};
